import TrainingSessionLesson from '../session-lesson';

/**
 * Create the action
 */

const { thunk, request, success, error } = TrainingSessionLesson.store((data, fetch) => {
    // Prepare request
    let formData = new FormData();
    ['title', 'description', 'order_index', 'evidence_required', 'is_published']
        .map(key => data[key] !== undefined ? formData.append(key, data[key]) : null);
    
    return fetch.post(`/trainings/${data.trainingId}/sessions/${data.sessionId}/lessons`, formData);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
